import { on, off } from '@/public/components/kye-table2/utils/dom.js'

const eventMap = {
  mousedown: 'mousedown',
  mouseup: 'mouseup',
  mousemove: 'mousemove',
  mouseover: 'mouseover'
}

const classNameMap = {
  leftTableClass: '.kye-table-v2__left-table',
  checkBoxColumnClass: '.table2_checkbox',
  checkBoxClassToVm: '.el-checkbox'
}

const lifecycleHooks = {
  beforeDestroy: 'hook:beforeDestroy'
}

const watchKeyName = 'showSelection'

class Table2BatchCheckboxDragSelect {
  constructor(option) {
    this.init(option)
  }

  init(option = {}) {
    this.initOption(option)
    this.initStates()
    this.bindHandlers()
    this.initEvent()
  }

  initOption(option) {
    const { vm: tableVm } = option
    this.tableEl = tableVm && tableVm.$el
    this.table2LeftEl = this.tableEl && this.tableEl.querySelector(classNameMap.leftTableClass)
    this.option = option
  }

  initStates() {
    this.states = {
      isMousedown: false,
      curRowIndex: null
    }
  }

  bindHandlers() {
    this.handleMousedown = this.handleMousedown.bind(this)
    this.handleMouseUp = this.handleMouseUp.bind(this)
    this.handleMousemove = this.handleMousemove.bind(this)
  }

  initEvent() {
    on(this.tableEl, eventMap.mousedown, this.handleMousedown)
    on(this.tableEl, eventMap.mouseup, this.handleMouseUp)
    on(this.table2LeftEl, eventMap.mouseover, this.handleMousemove)
    document.addEventListener(eventMap.mouseup, this.handleMouseUp)
  }

  handleMousemove(event = {}) {
    if (!this.states.isMousedown) return
    const { target } = event
    const table2CheckboxVm = this.getCheckboxVm(target)
    const rowIndex = table2CheckboxVm && table2CheckboxVm.rowIndex
    // 相同元素移动不做处理
    if (this.states.curRowIndex === rowIndex) return
    // 记录当前行下标
    this.states.curRowIndex = rowIndex
    table2CheckboxVm && table2CheckboxVm.handleMousemove && table2CheckboxVm.handleMousemove()
  }

  getCheckboxVm(el) {
    const table2CheckboxWrap = el && el.closest(classNameMap.checkBoxColumnClass)
    if (table2CheckboxWrap) {
      const checkboxEl = table2CheckboxWrap.querySelector(classNameMap.checkBoxClassToVm)
      let vm = (checkboxEl && checkboxEl.__vue__) || {}
      // $parent 属于勾选状态
      return vm.handleMousemove ? vm : vm.$parent
    }
    return null
  }

  handleMousedown() {
    this.states.isMousedown = true
    if (!this.table2LeftEl) {
      this.getLeftTableEl()
    }
    on(this.table2LeftEl, eventMap.mousemove, this.handleMousemove)
  }

  handleMouseUp() {
    this.states.isMousedown = false
    off(this.table2LeftEl, eventMap.mousemove, this.handleMousemove)
  }

  getLeftTableEl() {
    this.table2LeftEl = this.tableEl && this.tableEl.querySelector(classNameMap.leftTableClass)
  }

  destroy() {
    off(this.tableEl, eventMap.mousedown, this.handleMousedown)
    off(this.tableEl, eventMap.mouseup, this.handleMouseUp)
    document.removeEventListener(eventMap.mouseup, this.handleMouseUp)
  }
}

export function createBatchCheckboxDragSelect(vm) {
  if (!vm) return

  const watchOption = {
    immediate: true
  }

  let batchCheckboxDragSelect = null

  const unWatch = vm.$watch(
    watchKeyName,
    isStart => {
      batchCheckboxDragSelect && batchCheckboxDragSelect.destroy()
      if (isStart) {
        batchCheckboxDragSelect = new Table2BatchCheckboxDragSelect({ vm })
      }
    },
    watchOption
  )

  vm.$on(lifecycleHooks.beforeDestroy, () => {
    unWatch()
    batchCheckboxDragSelect && batchCheckboxDragSelect.destroy()
    batchCheckboxDragSelect = null
  })
}




// WEBPACK FOOTER //
// ./src/public/components/kye-table2/plugins/batch-checkbox-drag-select.js